import obelisk from '../../../clients/obelisk';

export const TranslationsGet = async (abbr = 'ENG') =>
  await obelisk().get('translations/GetTranslationsByShortcode', { shortcode: abbr });

export const TranslationsGetByDefault = async () =>
  await obelisk()
    .get('translations/GetTranslationsByDefault')
    .then((res) => res.data);

export const TranslationGetLanguages = async (asObj = false) =>
  await obelisk().get('translations/GetTranslationLocales', { list: true, asObj });

export const TranslationCreateLocale = async (data) =>
  await obelisk().post('translations/CreateTranslationLocale', data);

export const TranslationUpdateTranslationLocale = async (data) =>
  await obelisk().patch(`translations/UpdateTranslationLocale`, data);

export const TranslationDeleteTranslationLocale = async (id) =>
  await obelisk().delete(`translations/DeleteTranslationLocale`, { id });

export const TranslationGetTranslations = async (lang) =>
  await obelisk()
    .get('translations/GetTranslations', { Id: lang })
    .then((res) => res.data);

export const TranslationCreateTranslation = async (data) =>
  await obelisk().post('translations/BatchCreateTranslation', { translations: data });

export const TranslationUpdateTranslation = async (data) =>
  await obelisk()
    .patch(`translations/UpdateTranslation`, data)
    .then((res) => res?.data);

export const TranslationDeleteTranslation = async (Id) =>
  await obelisk().delete(`translations/DeleteTranslation`, { Id });
